// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MenuDropdown_container__Kffdm{
    position: relative;
}
.MenuDropdown_button__p\\+8Ns{
    display: flex;
    align-items: center;
    position: relative;
    height: 24px;
    padding: 15px 26px;
    border: 1px solid #1F363D1A;
    border-radius: 500px;
    cursor: pointer;
}
.MenuDropdown_icon__TZ-PB{
    position: relative;
    top: 3px;
    height: 24px;
    width: 24px;
    margin-right: 15px;
}
.MenuDropdown_label__-Fe4g{
    position: relative;
    top: -2.5px;
    color: #274C77;
    font-family: 'Gotham Medium', serif;
}
.MenuDropdown_downCaret__azs4A, .MenuDropdown_upCaret__-HutL{
    position: relative;
    top: 1.5px;
    height: 7px;
    width: 12px;
    margin-left: auto;
}
.MenuDropdown_options__1Rquw{
    position: absolute;
    right: 0;
    width: calc(100% - 52px);
    padding: 3px 26px;
    background-color: #FFFFFF;
    border: 1px solid #1F363D1A;
    border-radius: 10px;
    box-shadow: 0 3px 12px 0 #00000012;
}
.MenuDropdown_option__L0T4S{
    padding-top: 15px;
    padding-bottom: 15px;
    color: #1F363D;
    font-family: 'Gotham Medium', serif;
    cursor: pointer;
}
.MenuDropdown_option__L0T4S:not(:last-child){
    border-bottom: 1px solid #1F363D1A;
}
.MenuDropdown_selected__ZAVox{
    color: #274C77;
}
.MenuDropdown_menuLinkIcon__d42J-{
    position: relative;
    top: -1px;
    height: 24px;
    width: 24px;
    margin-right: 15px;
}
.MenuDropdown_menuLinkLabel__WUykI{
    position: relative;
    top: -6px;
}`, "",{"version":3,"sources":["webpack://./src/components/profile/MenuDropdown.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,oBAAoB;IACpB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,wBAAwB;IACxB,iBAAiB;IACjB,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;IACd,mCAAmC;IACnC,eAAe;AACnB;AACA;IACI,kCAAkC;AACtC;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,SAAS;AACb","sourcesContent":[".container{\n    position: relative;\n}\n.button{\n    display: flex;\n    align-items: center;\n    position: relative;\n    height: 24px;\n    padding: 15px 26px;\n    border: 1px solid #1F363D1A;\n    border-radius: 500px;\n    cursor: pointer;\n}\n.icon{\n    position: relative;\n    top: 3px;\n    height: 24px;\n    width: 24px;\n    margin-right: 15px;\n}\n.label{\n    position: relative;\n    top: -2.5px;\n    color: #274C77;\n    font-family: 'Gotham Medium', serif;\n}\n.downCaret, .upCaret{\n    position: relative;\n    top: 1.5px;\n    height: 7px;\n    width: 12px;\n    margin-left: auto;\n}\n.options{\n    position: absolute;\n    right: 0;\n    width: calc(100% - 52px);\n    padding: 3px 26px;\n    background-color: #FFFFFF;\n    border: 1px solid #1F363D1A;\n    border-radius: 10px;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n.option{\n    padding-top: 15px;\n    padding-bottom: 15px;\n    color: #1F363D;\n    font-family: 'Gotham Medium', serif;\n    cursor: pointer;\n}\n.option:not(:last-child){\n    border-bottom: 1px solid #1F363D1A;\n}\n.selected{\n    color: #274C77;\n}\n.menuLinkIcon{\n    position: relative;\n    top: -1px;\n    height: 24px;\n    width: 24px;\n    margin-right: 15px;\n}\n.menuLinkLabel{\n    position: relative;\n    top: -6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MenuDropdown_container__Kffdm`,
	"button": `MenuDropdown_button__p+8Ns`,
	"icon": `MenuDropdown_icon__TZ-PB`,
	"label": `MenuDropdown_label__-Fe4g`,
	"downCaret": `MenuDropdown_downCaret__azs4A`,
	"upCaret": `MenuDropdown_upCaret__-HutL`,
	"options": `MenuDropdown_options__1Rquw`,
	"option": `MenuDropdown_option__L0T4S`,
	"selected": `MenuDropdown_selected__ZAVox`,
	"menuLinkIcon": `MenuDropdown_menuLinkIcon__d42J-`,
	"menuLinkLabel": `MenuDropdown_menuLinkLabel__WUykI`
};
export default ___CSS_LOADER_EXPORT___;
